import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { HYDRATE } from 'next-redux-wrapper'
import { HelpState } from './types'
import { IHelpInstruction, IHelpSection } from '@/types/help.interface'
import { IArticleShort } from '@/types/article.interface'
import { IGlossaryArticle } from '@/types/glossary.interface'

const initialState: HelpState = {
  articles: [],
  glossaryArticles: [],
  instructions: [],
  sections: [],
}

const helpSlice = createSlice({
  name: 'help-data',
  initialState,
  reducers: {
    setHelpSections(state, action: PayloadAction<IHelpSection[]>) {
      state.sections = action.payload
    },
    setHelpInstructions(state, action: PayloadAction<IHelpInstruction[]>) {
      state.instructions = action.payload
    },
    setHelpArticles(state, action: PayloadAction<IArticleShort[]>) {
      state.articles = action.payload
    },
    setHelpGlossaryArticles(state, action: PayloadAction<IGlossaryArticle[]>) {
      state.glossaryArticles = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(HYDRATE, (state, action) => {
      return {
        ...state,
        // @ts-ignore
        ...action.payload.helpData,
      }
    })
  },
})

export const { setHelpArticles, setHelpGlossaryArticles, setHelpSections, setHelpInstructions } =
  helpSlice.actions

export default helpSlice
